import store from 'store';
import profileService from 'services/api/customer/profile-service';

/**
 * На хард-релоаде страницы user.currentProject в сторе ещё не
 * гидратирован (fetchProfile выполняется асинхронно после
 * refreshToken в App и может завершиться позже loader'а).
 * Если стор пуст, запрашиваем user/me напрямую, чтобы loader не
 * ушёл в бэкенд с пустым projectTag.
 */
async function resolveProjectContext(): Promise<{ regionId: number, projectTag: string }> {
  const { region, currentProject } = store.getState().user;
  if (region?.id && currentProject?.tag) {
    return { regionId: region.id, projectTag: currentProject.tag };
  }

  try {
    const { data } = await profileService.getProfile();
    return {
      regionId: data.data.currentRegion?.id || region?.id || 0,
      projectTag: data.data.currentProject?.tag || currentProject?.tag || '',
    };
  } catch {
    return { regionId: region?.id || 0, projectTag: currentProject?.tag || '' };
  }
}

export default resolveProjectContext;
